import React from "react";
import { DateRangeChartProps } from "../types";
import { DateRangeChartComponent } from "../components";
import { generateDataCategories, generateXAxisData, getEmissionType } from "../utils";

export const ScopeChart = ({
  dateRangeType,
  subTabName,
  currentMainTab,
  ...props
}: DateRangeChartProps) => {
  const generateChartData = (data: any[], emissionType: string) =>
    generateDataCategories(data, emissionType, "scope");

  const generateSeriesData = (chartData: any, sortedCategories: string[]) =>
    generateXAxisData(
      chartData,
      sortedCategories,
      dateRangeType,
      getEmissionType(
        subTabName === "location" || subTabName === "market",
        currentMainTab === "Consumption",
        subTabName
      )
    );

  const getScopeSeriesNames = (key: string) => ({
    "scope1": "Scope 1",
    "scope2": "Scope 2",
    "NO_SCOPE": "No Scope",
  })[key];

  return (
    <DateRangeChartComponent
      {...props}
      dateRangeType={dateRangeType}
      subTabName={subTabName}
      currentMainTab={currentMainTab}
      chartType="scope"
      dataKey="scope"
      generateChartData={generateChartData}
      generateSeriesData={generateSeriesData}
      getSeriesNames={(key: string) => getScopeSeriesNames(key) || key}
    />
  );
};
